import React, { ReactElement } from "react";

export const ErrorLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { ErrorPage } = await import("@workflows/support/ErrorPage");
  const WrappedUserManagement = (): ReactElement => <ErrorPage type={404} />;
  return { Component: WrappedUserManagement };
};

export const UserAccountDeletedLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { UserAccountDeletedPage } = await import("@workflows/support/UserAccountDeletedPage");
  const WrappedUserManagement = (): ReactElement => <UserAccountDeletedPage />;
  return { Component: WrappedUserManagement };
};

export const UserSubmitForApprovalLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { UserToSubmitForApprovalPage } = await import("@workflows/support/UserToSubmitForApprovalPage");
  const WrappedUserManagement = (): ReactElement => <UserToSubmitForApprovalPage />;
  return { Component: WrappedUserManagement };
};

export const UserPendingApprovalLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { UserPendingApprovalPage } = await import("@workflows/support/UserPendingApprovalPage");
  const WrappedUserManagement = (): ReactElement => <UserPendingApprovalPage />;
  return { Component: WrappedUserManagement };
};

export const LogoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { LogoutPage } = await import("@workflows/support/LogoutPage");
  const WrappedUserManagement = (): ReactElement => <LogoutPage />;
  return { Component: WrappedUserManagement };
};
